import {
  BarComponent,
} from "components/VatReturn";
import React, { Fragment } from "react";
import styles from "../../components/VatReturn/VatReturn.module.scss";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import { useState, useEffect } from "react";
import VatReturnTab from "./VatReturnTab";
import SalesTab from "./SalesTab";
import PurchaseTab from "./PurchaseTab";
import * as api from "../../api/index";
import { Button } from "@progress/kendo-react-buttons";

const VatDetails = (props) => {
  const [tabs] = useState([
    "VAT Return",
    "Purchase",
    "Sales",
  ]);
  const [selected, setSelected] = React.useState(0);
  const [calculationData, setCalculationData] = useState({});
  const [salesTransactions, setSalesTransactions] = useState([]);
  const [purchaseTransactions, setPurchaseTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSelect = (e) => setSelected(e.selected);

  const getVatReturnData = async () => {
    try {
      setLoading(true);
      const data = await api.getVatReturnData(
        props.item.fromDate,
        props.item.toDate
      );
      const responseData = data?.data?.data;
      setCalculationData(responseData?.calculations);
      setSalesTransactions(responseData?.salesTransactions ?? []);
      setPurchaseTransactions(responseData?.purchaseTransactions ?? []);
    } catch (error) { }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVatReturnData();
  }, [props.item]);

  return (
    <Fragment>
      <TabStrip
        keepTabsMounted={true}
        selected={selected}
        onSelect={handleSelect}
        className={`pagetab ${styles['vat-details-container']}`}
      >
        {tabs.map((item, index) => (
          <TabStripTab
            key={index}
            title={
              <PageTabItemTitle
                title={item}
                index={tabs.indexOf(item)}
                selected={selected}
              />
            }
          >
            <div className={styles['tab-back-btn']}>
              <Button onClick={props.onBack} className="common-btn bgsecondary text-black  button-small">Back</Button>
            </div>

            <div className={styles["company-tabs"]}>
              {item === "VAT Return" && (
                <VatReturnTab
                  data={calculationData}
                  item={props.item}
                  hmrcMtd={props.hmrcMtd}
                />
              )}
              {item === "Purchase" && (
                <PurchaseTab
                  calculations={calculationData}
                  purchaseTransactions={purchaseTransactions}
                  loading={loading}
                />
              )}
              {item === "Sales" && (
                <SalesTab
                  calculations={calculationData}
                  salesTransactions={salesTransactions}
                  loading={loading}
                />
              )}

            </div>
          </TabStripTab>
        ))}
      </TabStrip>

      {
        props.hmrcMtd && (
          <div className={styles["vat-footer"]}>
            <BarComponent />
            <div className="d-flex justify-content-end align-items-center ps-3 pe-3 pt-2 pb-2">
              <Button className="common-btn me-1">Submit to HMRC</Button>
            </div>
          </div>
        )
      }
    </Fragment >
  );
};

export default VatDetails;
